import React from 'react';
import {getActivateNiudErrorMessage, getActivateNiudSuccessMessage} from '../constants';

const ActivateNiudResultMessage = ({type, apiError, apiErrorMessage, apiSuccessMessage, formattedPortTime}) => {
  if (type === 'error' && apiError) {
    return (
      <div className='activate-niud-message activate-niud-message--error'>
        <p>{getActivateNiudErrorMessage(apiError, apiErrorMessage)}</p>
      </div>
    );
  }

  if (type === 'success') {
    return (
      <div className='activate-niud-message activate-niud-message--success'>
        <p className='activate-niud-message__subtitle'>
          {getActivateNiudSuccessMessage(apiSuccessMessage, formattedPortTime)}
        </p>
      </div>
    );
  }

  return null;
};

export default ActivateNiudResultMessage;
